'use strict';

const tabsTokens = (theme) => ({
    // Typography
    tabFontFamily: theme.typography.fontFamily.regular,
    tabFontWeight: theme.typography.fontWeight.bold,
    tabFontSize: theme.typography.fontSize.s,
    tabLineHeight: theme.typography.lineHeight.s,
    tabLetterSpacing: theme.typography.letterSpacing.m,
    // Spacing
    tabPaddingX: theme.space.component.x.m,
    tabPaddingY: theme.space.component.y.s,
    // TAB DEFAULT
    tabDefaultTextColor: theme.colors.body.text,
    // Active
    tabDefaultActiveTextColor: theme.colors.primary.normal,
    tabDefaultActiveBoxShadow: '0px 2px 0px currentColor',
    // Hover
    tabDefaultHoverTextColor: theme.colors.primary.dark,
    tabDefaultHoverBoxShadow: '0px 2px 0px currentColor',
    // Focus
    tabDefaultFocusTextColor: theme.colors.primary.darker,
    tabDefaultFocusBoxShadow: '0px 2px 0px currentColor',
    // TAB DATATABLE
    tabDatatableBorderRadius: theme.radiuses.m,
    tabDatatableTextColor: theme.colors.body.text,
    tabDatatableBackgroundColor: 'transparent',
    // Active
    tabDatatableActiveTextColor: theme.colors.primary.normal,
    tabDatatableActiveBackgroundColor: theme.palette.blue400Alpha,
    // Hover
    tabDatatableHoverTextColor: theme.colors.primary.dark,
    tabDatatableHoverBackgroundColor: theme.palette.blue400Alpha,
    // Focus
    tabDatatableFocusTextColor: theme.colors.primary.normal,
    tabDatatableFocusBackgroundColor: theme.palette.blue400Alpha,
});

exports.tabsTokens = tabsTokens;
//# sourceMappingURL=tabs.js.map
